module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAd0lEQVR4AWOgC+B3X08kopuG/+jg27+fD/7/efn//080Cawafty+c/ra+XPXL56/d+/M///fCWj49/d93eS+jatLlq5ob5ja///fW0I2/Pu5ZHNXQW95VlfFim0T0VyF3Q+/fz7Ze3Lv/lP7/vx6hiY1GONhUAIA/0UYS5C9KXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SV.png
// module id = 1271
// module chunks = 0